/* ============================================================
   NOVA STUDIO – Skate Magazine JS
   assets/nova-skate.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- SCROLL REVEAL ----
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = entry.target.dataset.rotate || 'translateY(0)';
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.sk-product-card, .sk-review-card, .sk-collection-card, .sk-stat-box').forEach(function(el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity 0.6s ' + (i * 0.05) + 's ease, transform 0.6s ' + (i * 0.05) + 's ease';
    observer.observe(el);
  });

  // ---- TOAST ----
  window.skShowToast = function() {
    var toast = document.getElementById('sk-toast');
    if (!toast) return;
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 2500);
  };

  // ---- CART COUNT ----
  window.skUpdateCartCount = function() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var el = document.getElementById('cart-count');
        if (el) el.textContent = cart.item_count;
      }).catch(function() {});
  };

  // ---- QUICK ADD ----
  window.skQuickAdd = function(btn, variantId) {
    if (!variantId) return;
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(function(r) { if (!r.ok) throw new Error('err'); return r.json(); })
    .then(function() {
      btn.textContent = '✓ Drin!';
      skShowToast(); skUpdateCartCount();
      setTimeout(function() { btn.textContent = 'In den Warenkorb'; btn.disabled = false; }, 2000);
    })
    .catch(function() { btn.textContent = 'Fehler!'; btn.disabled = false; });
  };

  // ---- PRODUKT FORM ----
  var pForm = document.getElementById('product-form');
  if (pForm) {
    pForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var vid = document.getElementById('variantId');
      if (!vid || !vid.value) return;
      var btn = pForm.querySelector('.sk-add-to-cart-full');
      var orig = btn.textContent;
      btn.textContent = '...'; btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid.value), quantity: 1 })
      })
      .then(function(r) { if (!r.ok) throw new Error('err'); return r.json(); })
      .then(function() {
        btn.textContent = '✓ Im Warenkorb!';
        skShowToast(); skUpdateCartCount();
        setTimeout(function() { btn.textContent = orig; btn.disabled = false; }, 2000);
      })
      .catch(function() { btn.textContent = 'Fehler – nochmal!'; btn.disabled = false; });
    });
  }

  // ---- GRÖßENAUSWAHL ----
  window.skSelectOption = function(btn) {
    var group = btn.closest('.sk-size-grid');
    if (group) group.querySelectorAll('.sk-size-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    skUpdateVariant();
  };

  function skUpdateVariant() {
    if (!window.skProductVariants) return;
    var opts = [];
    document.querySelectorAll('.sk-option-group').forEach(function(g) {
      var a = g.querySelector('.sk-size-btn.active');
      if (a) opts.push(a.dataset.optionValue);
    });
    var v = window.skProductVariants.find(function(v) {
      return v.options.every(function(o, i) { return o === opts[i]; });
    });
    if (v) {
      var inp = document.getElementById('variantId');
      if (inp) inp.value = v.id;
      var btn = document.querySelector('.sk-add-to-cart-full');
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft'; }
      var si = document.querySelector('.sk-stock-info');
      if (si) {
        si.className = 'sk-stock-info ' + (v.available ? 'sk-in-stock' : 'sk-out-of-stock');
        si.textContent = v.available ? 'Auf Lager – Lieferzeit 10–14 Tage' : 'Ausverkauft';
      }
    }
  }

  // ---- BILD WECHSEL ----
  window.skChangeImage = function(thumb, src) {
    var img = document.getElementById('mainImg');
    if (img) img.src = src;
    document.querySelectorAll('.sk-product-thumb').forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  };

  // ---- RABATTCODE ----
  window.skApplyDiscount = function() {
    var code = document.getElementById('discount-input');
    var msg = document.getElementById('discount-msg');
    if (!code || !code.value.trim()) {
      if (msg) { msg.style.display = 'block'; msg.style.color = 'var(--muted)'; msg.textContent = 'Bitte einen Code eingeben!'; }
      return;
    }
    if (msg) { msg.style.display = 'block'; msg.style.color = 'var(--ink)'; msg.textContent = '✓ Code wird an der Kasse angewendet!'; }
    var btn = document.querySelector('button[name="checkout"]');
    if (btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = '/checkout?discount=' + encodeURIComponent(code.value.trim());
      }, { once: true });
    }
  };

});

  // ---- VARIANTE IM WARENKORB ÄNDERN ----
  window.skUpdateVariantInCart = function(lineIndex, newVariantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 1, id: parseInt(newVariantId) })
    })
    .then(function(r) { return r.json(); })
    .then(function() { window.location.reload(); })
    .catch(function(e) { console.error('Variant update error:', e); });
  };

